import WithSystem from './../service/WithSystem';

class ProductDropDown extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      isFetching: false,
      product_type:'all'
    }
    this.renderData  = []
  } 
   
  componentDidMount() {
    this.FormDataAsJson();
  }
  setSelectedProducts = (id,name) => {
    if(id == "0_all") {
      this.props.setGlobalState({ 'product_id': '', 'product_name': '' });
    }
    else {
      this.props.setGlobalState({ 'product_id': id, 'product_name': name });
    }
    __filter_applied      = true;
    $("#bc-datatable").DataTable().state.clear();
  }
  FormDataAsJson   = async () => {
    let product_type = 'all';//(this.props.queryFilter.product_type != false)?this.props.queryFilter.product_type : 'all';    
    let apiCall    = `${admin_url}report/course_bundle`;
    let formData   = new FormData();
    formData.append("type", product_type);
    const fetchOptions = {
      method: "POST",
      body: formData
    };
    const response   = await fetch(apiCall, fetchOptions);
    let apiResponse  = await response.json();
    let renderData   = apiResponse.courses;
    this.renderData  = renderData;
    this.props.setGlobalState({ 'products': renderData });
    this.setState({isFetching: true});
    this.renderProductList();
  }
  componentDidUpdate(prevProps, newProps) {    
    if (this.props.queryFilter.product_type !== this.props.queryFilter.old_product_type) {
      __filter_applied= true;       
        this.props.setGlobalState({ 'old_product_type': this.props.queryFilter.product_type });
        this.FormDataAsJson();  
        $("#progress-filter-loading").addClass("show");
    }
  }
  renderProductList(){
    if(this.state.isFetching) {
      var initialData =[{id: "all", title: "All product", type: "0"}];
      var renderData = initialData.concat(this.renderData);
      var type = this.props.queryFilter.product_type;
      if(type) {
        var filterData = renderData.filter(function(item){
          return item.type == type;
        });
        renderData = initialData.concat(filterData);
      }     
      const listItems = renderData.map((course) =>      
      <li key={`${course.type}_${course.id}`}><a href="#" id={`${course.type}_${course.id}`} onClick={() => this.setSelectedProducts(`${course.type}_${course.id}`,`${course.title}`)} >{course.title}</a></li>
        );
      return (<ul className="dropdown-menu white inner-scroll" id="exam_list">
                {listItems}
              </ul>);
    }   
    return null;
 }
  render() {
      return (
        <div className="rTableCell dropdown">
          <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><span id="filter_exam">{this.props.queryFilter.product_name != false?`${this.props.queryFilter.product_name}`:`All product`}</span><span className="caret"></span></a>
          { this.renderProductList() }       
        </div> 
      );   
  }
}
export default WithSystem(ProductDropDown);

